import React from 'react'
import Vegetables from '../Components/Images/Home/kpn-vegetables.png'
import Fruits from '../Components/Images/Home/kpn-fruits.png'
import Grocery from '../Components/Images/Home/kpn-grocery.png'
import { Link } from 'react-router-dom'
import { Carousel } from '../Components/Carousel/Carousel'
import { Review } from '../Components/Reviews/Review'
import '../Components/Itemcard/style.css'
import { Services } from '../Components/Services/Services'
import Banner5 from '../Components/Images/banner5.jpg'
import About from '../Components/Images/kpn-vegetables.png'

export const Home = () => {

  return (
    <div className='home'>
      <div className="banners">
      <Carousel />
      </div>
      <div className='items'>
        <div className="img-container">
          <div className="box">
            <Link to='/vegetables' ><img src={Vegetables} alt='' /></Link>
            <p>Vegetables</p>
          </div>
        </div>

        <div className="img-container">
          <div className="box">
            <Link to='/fruits' ><img src={Fruits} alt='' /></Link>
            <p>Fruits</p>
          </div>
        </div>

        <div className="img-container">
          <div className="box">
            <img src={Grocery} alt='' />
            <p>Grocery</p>
          </div>
        </div>
      </div>
      <div className='about'>

      <div className='about-img'>
      <img src={About} alt='img' />
      </div>


      <div className="about-content">
      <h3>Our Quality</h3>
      <h1>We Provide Fresh Fruits & Vegetables For Your Family</h1>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt iste consequatur voluptate aut voluptates? Maiores in distinctio eos corporis corrupti tenetur molestias nulla quis </p>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius provident quis minima? Repellat dicta minima deserunt, facilis ipsam amet libero ea exercitationem iure beatae qui maxime. Eligendi aliquid esse assumenda?</p>
      </div> 
    </div>


      

      <Services />
      <div className='homebanner5'>
        <img src={Banner5} alt="" />
      </div>
      <Review />



    </div>
  )
}
